"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ResultsListConfig_1 = __importDefault(require("../../../constants/ResultsListConfig"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./../styles.module.scss"));
var ItemList = function (_a) {
    var handleSortChange = _a.handleSortChange, selected = _a.selected, handleClose = _a.handleClose;
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.useState(selected), sortBy = _b[0], setSortBy = _b[1];
    var SORT_BY = ResultsListConfig_1.default.SORT_BY;
    react_1.useEffect(function () {
        window.scrollTo(0, 0);
    }, [sortBy]);
    var sortOptions = react_1.useMemo(function () {
        return SORT_BY.OPTIONS.map(function (optionKey) {
            return {
                key: optionKey,
                text: t(SORT_BY.TRANSLATION_NAMESPACE + '.' + optionKey),
            };
        });
    }, []);
    var handleClick = function (ev, elem) {
        setSortBy(elem.key);
        handleSortChange(elem.key);
        handleClose();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, sortOptions.map(function (elem) {
        return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.post_sort_item, elem.key === sortBy ? styles_module_scss_1.default.active : null), onClick: function (e) {
                handleClick(e, elem);
            }, key: elem.key },
            react_1.default.createElement("div", null, elem.text),
            elem.key === sortBy ? (react_1.default.createElement("i", { className: "cm-icon icon-check-mark" })) : null));
    })));
};
exports.default = ItemList;
